$(document).ready(function(){
  if ($(window).width() < 1200) {
    $(".filter-and-coll-flex .tabs-with-sort facet-filters-form.facets").remove();
  
  }
  else{
$(".filter-and-coll-flex .section-heading.section-heading--facets.gutter-bottom--page facet-filters-form").remove();
  }
   $(".slider-block-rev").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
   infinite:true,
        responsive: [
     
           {
        breakpoint: 992,
        settings: {
   dots: true,
           slidesToShow: 2,
        }
      },
          {
        breakpoint: 577,
        settings: {
   dots: true,
           slidesToShow: 1,
            centerMode:true,
          centerPadding:'39px',
        
          infinite:true,
        }
      }
          ]
     
   });
    $(".slider-block-insta.slider-1").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:true,
        responsive: [
      {
        breakpoint: 992,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 3,
        }
      },
           {
        breakpoint: 768,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 2,
        }
      },
          {
        breakpoint: 577,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 1,
            centerMode:true,
          centerPadding:'43px',
        
          infinite:true,
        }
      }
          ]
     
   });
  $(".slider-block-insta.slider-2").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
        responsive: [
      {
        breakpoint: 992,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 3,
        }
      },
           {
        breakpoint: 768,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 2,
        }
      },
          {
        breakpoint: 577,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 1,
          
        }
      }
          ]
     
   });
   $(".grid-slider.first-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
        responsive: [
      {
        breakpoint: 992,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 3,
        }
      },
           {
        breakpoint: 768,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 2,
        }
      },
          {
           breakpoint: 355,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 1,
        }
      }
      
          ]
     
   });
  var slidesToShow = 4;
// var childElements = $('.active-content .grid-slider').children().length;
// if( slidesToShow > (childElements-1) ) {
//   slidesToShow = (childElements-1);
// }
  $(".active-content .grid-slider").slick({
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
   infinite:false,
  
        responsive: [
      {
        breakpoint: 992,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 3,
        }
      },
           {
        breakpoint: 768,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 2,
        }
      },
          {
           breakpoint: 355,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 1,
        }
      }
      
          ]
     
   });
  // $(".active-content .grid-slider .product-item").css("min-width",$(".active-content .grid-slider .product-item").first().width()+ "px");
  $(".scroller-tabs").slick({
    slidesToScroll: 1,
    variableWidth:true,
    arrows: false,
    dots: false,
   infinite:true,
    focusOnSelect:false,
    
  });

$(document).on("click",".scroller-tabs p",function(){
  $(".scroller-tabs p").removeClass("active-tab");
  $(this).addClass("active-tab");
  $(".active-content .grid-slider.slick-initialized").slick('unslick');
  $(".collection-slider-tab").removeClass("active-content");
  $("#"+$(this).attr("data-hadle")).addClass("active-content");
 var slidesToShow = 4;
// var childElements = $("#"+$(this).attr("data-hadle")).find(".grid-slider").children().length;
// if( slidesToShow > (childElements-1) ) {
//    slidesToShow = (childElements-1);
// }
   $("#"+$(this).attr("data-hadle")).find(".grid-slider").slick({
    slidesToShow: slidesToShow,
    slidesToScroll:1 ,
    arrows: true,
    dots: false,
   infinite:false,
     
        responsive: [
      {
        breakpoint: 992,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 3,
        }
      },
           {
        breakpoint: 768,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 2,
        }
      },
          {
           breakpoint: 355,
        settings: {
    dots: true,
          arrows: false,
           slidesToShow: 1,
        }
      }
      
          ]
     
   });
});
$(window).on('load resize', function() {
    if ($(window).width() < 768) {
        // Initialize the slider if it's not already initialized
        $(".our-baked-good .slider-block-baked:not(.slick-initialized)").slick({
            slidesToShow: 1.27,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: false,
        });
    } else {
        // Destroy the slider if it's initialized
        $(".our-baked-good .slider-block-baked.slick-initialized").slick('unslick');
    }
});
  
});